<template>
  <v-img
    :lazy-src="imageItem.url"
    :src="imageItem.url">
    <v-container fill-height fluid v-if="userSignedIn"
    >
      <v-row
        align="end"
        justify="end"
        align-self="end">
        <v-spacer/>
        <v-col>
          <v-btn color="grey"
            icon
            rounded
            dark
            absolute
            v-if="false"
            @click.prevent="download"
            style="right: 64px; bottom: 12px;">
            <v-icon size="32">mdi-download</v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <v-btn color="pink"
            icon
            rounded
            dark
            absolute
            :loading="loading || forceLoading"
            @click.prevent="toggleFavourite"
            bottom
            style="right: 16px;">
            <v-icon size="32">{{isFavourite ? "mdi-heart": "mdi-heart-outline"}}</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-img>
</template>

<script>
const firebaseApp = require('firebase/app');
// const axios = require('axios').default;
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  props: {
    imageItem: {
      default: undefined,
      type: Object,
    },
    showFavIcon: {
      default: true,
      type: Boolean,
    },
    forceLoading: {
      default: false,
      type: Boolean,
    }
  },
  name: 'imagePreview',
  components: {
  },
  data() {
    return {
      loading: false,
      db: this.$root.$data.db,
      appState: this.$root.$data.appStore.state,
    }
  },
  computed: {
    isFavourite: function () {
      return this.imageItem.favouritedAt != undefined;
    },
    userSignedIn: function () {
      return this.appState.user.uid !== undefined;
    }
  },
  methods: {
    async toggleFavourite() {
      this.loading = true;
      try {
        await this.db.collection('image').doc(this.imageItem.id).update({
          favouritedAt: this.isFavourite ? firebaseApp.firestore.FieldValue.delete() : firebaseApp.firestore.FieldValue.serverTimestamp(),
        });
      } catch (error) {
        console.error(`Could not favourite image §{this.imageItem.id}: ${error}`);
      }
      this.loading = false;
    },
    download() {
      // TODO this does not handle CORS errors
      /*axios({
          url: this.imageItem.url,
          headers: {
          // remove headers
        },
          method: 'GET',
          responseType: 'arraybuffer',
      }).then((response) => {
           var fileURL = window.URL.createObjectURL(new Blob([response.data]));
           var fileLink = document.createElement('a');

           fileLink.href = fileURL;
           fileLink.setAttribute('download', this.imageItem.url);
           document.body.appendChild(fileLink);

           fileLink.click();
      });*/
    }
  },
}
</script>
